/**
 * Utility function to add hreflang tags for bilingual site support
 * English site: kidneypatientsupport.com
 * Japanese site: kidneypatientsupport.org
 */

interface HreflangConfig {
  enPath: string;
  jaPath?: string; // Optional - only if Japanese equivalent exists
}

export const updateHreflangTags = (config: HreflangConfig): void => {
  // Remove existing hreflang tags
  const existingTags = document.querySelectorAll('link[rel="alternate"][hreflang]');
  existingTags.forEach(tag => tag.remove());

  const enUrl = `https://kidneypatientsupport.com${config.enPath}`;
  
  // Always add self-referencing English tag
  const enTag = document.createElement('link');
  enTag.rel = 'alternate';
  enTag.hreflang = 'en';
  enTag.href = enUrl;
  document.head.appendChild(enTag);

  // Add Japanese tag only if equivalent page exists
  if (config.jaPath) {
    const jaUrl = `https://kidneypatientsupport.org${config.jaPath}`;
    const jaTag = document.createElement('link');
    jaTag.rel = 'alternate';
    jaTag.hreflang = 'ja';
    jaTag.href = jaUrl;
    document.head.appendChild(jaTag);
  }

  // Add x-default (always points to English)
  const defaultTag = document.createElement('link');
  defaultTag.rel = 'alternate';
  defaultTag.hreflang = 'x-default';
  defaultTag.href = enUrl;
  document.head.appendChild(defaultTag);
};